export const getEntityFullName = (data, activeLanguage) => {
    if (!data) return '*name data is null*';
    if (activeLanguage?.length > 0)
        return activeLanguage
            .filter(lang => data["name_" + lang.code])
            .map(lang => data["name_" + lang.code]).join("|")
    else {
        console.log("entity name data error: ", data, activeLanguage);
        return "*entity name data error*";
    }
}

export const getFileNameFromPath = (path) => {
    return path.replace(/^.*[\\/]/, '');
}
